// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import dataTableStyles from "@guestsupply/App/SharedStyles/MyAccountPages/List/DataTableStyles";
import myAccountFilterSectionStyles from "@guestsupply/App/SharedStyles/MyAccountPages/List/MyAccountFilterSectionStyles";
import { backorderManagementStyles } from "@guestsupply/App/Widgets/BackorderManagement/BackorderManagement";
import Close from "@guestsupply/XDL/Icons/Close";
import { createLinkIconStyles, mergeWithCss, xScreen } from "@guestsupply/XDL/Utilities";
import Truck from "@insite/mobius/Icons/Truck";
import { css } from "styled-components";

backorderManagementStyles.container = {
    css: css`
        overflow: auto;
    `,
};

backorderManagementStyles.centeringWrapper = {
    css: css`
        height: 100px;
        display: flex;
        align-items: center;
    `,
};

backorderManagementStyles.spinner = {
    css: css`
        margin: auto;
    `,
};

backorderManagementStyles.noResultsContainer = {
    css: css`
        padding: 20px 0;
    `,
};

backorderManagementStyles.noResultsText = {
    ...dataTableStyles.noResultsText,
};

backorderManagementStyles.filtersToggleWrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
        margin-top: 15px;
    `,
};

backorderManagementStyles.toggleFilterButton = {
    ...myAccountFilterSectionStyles.toggleFilterButton,
};

backorderManagementStyles.toggleFilterButtonIcon = {
    ...myAccountFilterSectionStyles.toggleFilterButtonIcon,
};

backorderManagementStyles.totalOrdersText = {
    ...mergeWithCss(myAccountFilterSectionStyles.orderCountText, {
        css: css`
            display: flex;
            align-items: center;
        `,
    }),
};

backorderManagementStyles.filtersWrapper = {
    ...mergeWithCss(myAccountFilterSectionStyles.searchFormStyles.wrapper, {
        css: css`
            padding: 30px;
            margin-bottom: 30px;
            display: flex;
            flex-wrap: wrap;
            align-items: flex-end;
            gap: 15px;
            ${xScreen("lte", "sm")} {
                justify-content: space-between;
            }
        `,
    }),
};

backorderManagementStyles.orderNumberWrapper = {
    css: css`
        max-width: 375px;
        ${xScreen("lte", "sm")} {
            max-width: none;
            width: calc(50% - 15px);
        }
        ${xScreen("lte", "xs")} {
            width: 100%;
        }
    `,
};

backorderManagementStyles.poNumberWrapper = {
    css: css`
        max-width: 375px;
        ${xScreen("lte", "sm")} {
            max-width: none;
            width: calc(50% - 15px);
        }
        ${xScreen("lte", "xs")} {
            width: 100%;
        }
    `,
};

backorderManagementStyles.filtersActionsWrapper = {
    css: css`
        display: flex;
        justify-content: flex-end;
        flex: 1;
    `,
};

backorderManagementStyles.clearButton = {
    variant: "tertiary",
    css: css`
        height: 36px;
        ${xScreen("lte", "xs")} {
            margin-top: 10px;
        }
    `,
};

backorderManagementStyles.appliedFiltersContainer = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        margin: 15px 0;
    `,
};

backorderManagementStyles.paginationWrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
        margin-bottom: 15px;
    `,
};

backorderManagementStyles.titleText = {
    size: 24,
};

backorderManagementStyles.orderLineNumberCells = {
    css: css`
        font-size: 13px;
    `,
};
backorderManagementStyles.orderQuantityCells = {
    css: css`
        font-size: 13px;
    `,
};

backorderManagementStyles.actionsWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
    `,
};

backorderManagementStyles.cancelProductText = {
    size: 12,
    css: css`
        margin-bottom: 5px;
    `,
};

backorderManagementStyles.cancelProductLink = {
    ...createLinkIconStyles(Close, {
        typographyProps: {
            size: 12,
            weight: "normal",
        },
        icon: {
            iconProps: {
                size: 10,
            },
            position: "left",
        },
        css: css`
            margin-bottom: 5px;
        `,
    }),
};

backorderManagementStyles.shipAltLink = {
    ...createLinkIconStyles(Truck, {
        typographyProps: {
            size: 12,
            weight: "normal",
        },
        icon: {
            iconProps: {
                size: 14,
            },
            position: "left",
        },
    }),
};

backorderManagementStyles.cancelProductModal = {
    sizeVariant: "medium",
    size: 500,
    cssOverrides: {
        modalTitle: css`
            &&& {
                border: none;
                min-height: 30px;
            }
        `,
    },
};

backorderManagementStyles.cancelProductModalTitle = {
    variant: "h2",
    weight: "normal",
    css: css`
        margin-bottom: 30px;
    `,
};

backorderManagementStyles.cancelProductConfirmButton = {
    variant: "primary",
    css: css`
        margin-bottom: 15px;
    `,
};

backorderManagementStyles.cancelProductCancelButton = {
    variant: "tertiary",
};

backorderManagementStyles.poNumberCells = {
    typographyProps: {
        ellipsis: true,
        css: css`
            display: block;
            max-width: fit-content;
            &&& {
                white-space: nowrap;
            }
        `,
    },
};
